import Vue from 'vue'
import Axios from 'axios'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/black-green-light.css'

Axios.defaults.baseURL = 'https://raw.githubusercontent.com/mayank1513/Karnamrita/master/';
Axios.defaults.headers.common.Accept = 'application/vnd.github.v3+json';
Axios.defaults.headers.common.Accept = 'application/vnd.github.inertia-preview+json';
Axios.defaults.headers.common.Accept = 'application/vnd.github.VERSION.html';

Object.defineProperty(Vue.prototype, '$http', {
    get(){
        return Axios;
    }
});


// WEBPACK FOOTER //
// ./src/bootstrap.js